import ServicePageTemplate from "@/components/ServicePageTemplate";

const FoodGrade = () => (
  <ServicePageTemplate
    seoTitle="Food Grade Warehousing | Varstar Alliance"
    seoDesc="FSMA-compliant food grade facilities for ambient, refrigerated, and frozen food and beverage products with audited handling protocols."
    canonical="/services/food-grade"
    h1="Food-safe handling, end to end."
    subtitle="FSMA-compliant facilities for ambient, refrigerated, and frozen food and beverage products."
    ctaText="Get a Food Grade Quote"
    body={"Food and beverage products demand stricter handling, sanitation, and traceability than general freight. Our food grade network is built on FSMA-compliant facilities, audited carriers, and temperature-monitored storage so your product reaches the shelf safely and compliantly."}
    benefits={[
      "FSMA-compliant facilities and carriers",
      "Ambient, refrigerated, and frozen storage in one network",
      "Food safety certified handling crews",
      "Integrated cold chain logistics from dock to door",
      "Audit-ready documentation and traceability",
    ]}
    equipment={["Ambient Storage", "Refrigerated Storage", "Frozen Storage"]}
  />
);

export default FoodGrade;